import { Injectable } from '@angular/core';
import { SettingsService } from '../common/settings.service';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/map';
import { DateRange, Fine } from '../../entity';

@Injectable()
export class FinesService {
    public finesDateRange: DateRange = null;
    public checksDateRange: DateRange = null;

    constructor(
        private settings: SettingsService,
        private http: Http,
        private authService: AuthService
    ) { }

    getFines(dateRange: DateRange) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        this.finesDateRange = dateRange;

        return this.http.post(this.settings.serverMain + 'Fine/GetFinesOf', dateRange, { headers: headers })
            .map(res => res.json());
    }

    printFine(id) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);

        return this.http.get(this.settings.serverMain + 'Fine/Print?fineId=' + id, { headers: headers })
            .map(res => res.json());
    }

    getFineDetails(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverMain + 'Fine/GetById?fineId=' + id, { headers: headers })
            .map(res => res.json());
    }

    getCheckedVehiclesbySupervisor(dateRange: DateRange) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);

        return this.http.post(this.settings.serverNomenclator + 'VehicleCheck/GetBySupervisor', dateRange, { headers: headers })
            .map(res => res.json());
    }

    getFinesBySupervisor(dateRange) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);

        return this.http.post(this.settings.serverMain + 'Fine/GetBySupervizor', dateRange, { headers: headers })
            .map(res => res.json());
    }

    getStatistics(dateRange) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);

        return this.http.post(this.settings.serverMain + 'Fine/GetStatistics', dateRange, { headers: headers })
            .map(res => res.json());
    }

    updateFine(fine: Fine) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);

        return this.http.post(this.settings.serverMain + 'Fine/Update', fine, { headers: headers })
            .map(res => res.json());
    }

    getVehicleChecks(dateRange: DateRange) {
        const headers = new Headers();
        headers.append('Authorization', this.authService.getUserToken());
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        this.checksDateRange = dateRange;

        return this.http.post(`${this.settings.serverNomenclator}VehicleCheck/GetVehicleChecksOf`, dateRange, { headers: headers })
            .map(res => res.json());
    }

    getVehicleCheckById(id){
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'v2/vehiclecheck/getbyid?vehicleCheckId=' + id, { headers: headers })
            .map(res => res.json());
    }
}
